import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Notification } from 'components';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';
import { Link } from 'react-router';

const ItemLink = (props) => props.url.match(new RegExp(`^https?:\/\/${window.location.host}`, 'gi')) ? (
  <Link to={props.url.replace(`https://${window.location.host}`,'').replace(`http://${window.location.host}`,'')}>
    {props.children}
  </Link>
) : (
  <a href={props.url} target='_blank'>
    {props.children}
  </a>
);

const Item = props => {
  let icon = null;

  switch(props.type) {
    case 'CLIENTS_IMPACTED':
      icon = <i className="fa-stack bg-danger">
        <i className="fa fa-users fa-stack-1x"></i>
        <i className="fa fa-bolt fa-stack-1x text-danger"></i>
      </i>
    break;
    case 'GENERAL_ANNOUNCEMENT':
      icon = <i className="fa fa-bullhorn bg-success"></i>
    break;
  }
  const content = (
    <span>
      <span className='image'>
        {icon}
      </span>
      <span className='title'>{props.title}</span>
      <span className='message'>{props.message}</span>
    </span>
  )
  return (
    <li>
      <a onClick={e => {
        e.preventDefault();
        if(props.onClose) {
          props.onClose(props);
        }
      }}><span className='pull-right'><i className="fa fa-close" /></span></a>
      {props.link ? (
        <ItemLink url={props.link}>
          {content}
        </ItemLink>
      ) : (
        <a onClick={e => {
          e.preventDefault();
          props.onClick(props);
        }} href='#'>
          {content}
        </a>
      )}
    </li>
  );
}

@connect(({ notifications }) => ({ notifications }), Actions)
class UserHeaderNotifications extends Component {
  state = {
    loading: true
  }
  constructor(props) {
    super(props);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getNotifications = this.getNotifications.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteAll = this.handleDeleteAll.bind(this);

    this.getNotifications()
      .catch(this.props.notify)
      .then(e => this.setState({ loading: false }));
  }
  getNotifications() {
    return Api.getUserNotifications()
      .then(({ results }) => this.props.setNotifications(results))
  }
  handleNotificationAction(notification) {
    switch(notification.type) {
      case 'GENERAL_ANNOUNCEMENT':
        break;
      case 'CLIENTS_IMPACTED':
        break;
      default:
        break;
    }
  }
  handleOpen() {
    const ids = this.props.notifications.map(({_id}) => _id);
    if(ids.length == 0) {
      return;
    }
    if(this.openTimer) {
      clearTimeout(this.openTimer);
    }

    this.openTimer = setTimeout(f => {
      Api.markUserNotifications(ids)
        .then(e => this.props.setNotifications([
          ...this.props.notifications.map(item => ({...item, status: 'VIEWED' }))
        ]))
        .catch(this.props.notify)
    }, 2000);
  }
  handleClose() {
    if(this.openTimer) {
      clearTimeout(this.openTimer);
    }
  }
  handleDeleteAll() {
    this.setState({ loading: true });
    Api.deleteUserNotifications(this.props.notifications.map(({_id}) => (_id)))
      .then(res => this.getNotifications())
      .catch(this.props.notify)
      .then(e => this.setState({ loading: false }));
  }
  handleDelete(notification) {
    this.setState({ loading: true });
    Api.deleteUserNotification(notification._id)
      .then(f => this.getNotifications())
      .catch(error => this.props.notify(error))
      .then(e => this.setState({ loading: false }));
  }
  render() {
    const { notifications } = this.props;
    const unreadNotifications = notifications.filter(({status}) => status == 'UNVIEWED').length;
    return (
      <Notification onOpen={this.handleOpen} onClose={this.handleClose} title={'Alerts'} iconClass='fa fa-bell' status="default" badge={unreadNotifications > 0 ? unreadNotifications : null}>
        {this.state.loading ? (
          <div className='text-center text-primary'>
            <i className="fa fa-spinner fa-spin fa-2x"></i>
          </div>
        ) : null}
        <ul>
          {(notifications || []).map(item => <Item {...item.notification} key={item._id} onClick={this.handleNotificationAction} onClose={e => this.handleDelete(item)} />)}
          {notifications.length == 0 ? (
            <li className="text-center">Nothing to report!</li>
          ) : null}
        </ul>
        {notifications.length > 0 ? <hr /> : null}
        {!this.state.loading && notifications.length > 0 ? <a href='#' onClick={e => {
          e.preventDefault();
          this.handleDeleteAll();
        }} className="view-more pull-right">Clear All</a> : null}
      </Notification>
    );
  }
}

export default UserHeaderNotifications;



// WEBPACK FOOTER //
// ./src/browser/components/users/user-header-notifications.js